<script lang="ts">
  import { default as CreditIndex } from "@retailer/svelte/Payments/Credits/detail/Index.svelte";
  import { params } from "@roxi/routify";

</script>

<CreditIndex invoiceId={$params.invoiceId} />
